import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const auth = useAuth();

    // If not logged in, redirect to the Admin (Login) page
    if (!auth.isLoggedIn) {
        // Use Navigate component to force a redirect
        return <Navigate to="/admin" replace />;
    }

    return children;
};

export default ProtectedRoute;